import { Component, OnInit } from '@angular/core';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { UserPermissionsService } from './services/user-permissions.service';
import { UsageTrackerService } from './services/usage-tracker.service';
import { BackendApiService } from './services/backend-api.service';
import * as Sentry from "@sentry/angular";
import {Router, NavigationStart} from "@angular/router";
import {NgbDateAdapter} from "@ng-bootstrap/ng-bootstrap";
import {NgbDatepickerStringAdapter} from "./utils/NgbDatepickerStringAdapter";
import {CDK_DRAG_CONFIG} from "@angular/cdk/drag-drop";
import { filter } from 'rxjs/operators';
import {LayoutService} from './services/layout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
      { provide: NgbDateAdapter, useClass: NgbDatepickerStringAdapter },
      { provide: CDK_DRAG_CONFIG, useValue: {zIndex: 10000} },
  ],
})
export class AppComponent implements OnInit {

  appHeaderDefaultClass: string = '';

  isLoading = true;
  isUserLoggedIn: boolean;
  // 'bare' pages (the SEO loop simple mode at /loop) render without the navbar and the breadcrumb.
  bareLayout = false;

  constructor(
    private modeService: ThemeModeService,
    private userPermissionsService: UserPermissionsService,
    private router: Router,
    private usageTracker: UsageTrackerService,
    private backendApiService: BackendApiService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit() {
      this.layoutService.layout$.subscribe(layout => {
          this.bareLayout = layout === 'bare';
      });
      this.router.events.pipe(
          filter((event: any) => event instanceof NavigationStart) // Cast event to any
      ).subscribe((event: NavigationStart) => {
          const searchParams = new URLSearchParams(event.url.split('?')[1]);
          const queryParams: { [key: string]: string } = {};
          searchParams.forEach((value, key) => {
              queryParams[key] = value;
          });

          if (queryParams["next"]) {
              let action = '';

              if (event.url.includes('#!')) {
                  const [_, fragment] = event.url.split('#!');

                  const fragmentParams = new URLSearchParams(fragment?.split('?')[1]);

                  if (fragmentParams.has('action')) {
                      action = fragmentParams.get('action') || '';
                  }
              }

              let nextUrl = queryParams["next"];
              if (action) {
                  nextUrl += `?action=${action}`;
              }

              sessionStorage.setItem("next", nextUrl);
          }

          if (event.url !== "/" && !(event.url).includes("/auth/login")) {
              // console.log("redirect to new Hexagon", "/new_cdb" + event.url);
              sessionStorage.setItem("next", "/new_cdb" + event.url);
          }
      });

    this.loadUserDetails();
  }

  loadUserDetails() {
    this.userPermissionsService
      .loadPermissions()
      .then(authResponse => {
          this.isUserLoggedIn = authResponse.user;
          this.modeService.init();
          Sentry.setUser({
              id: authResponse.user.id,
              email: authResponse.user.email,
              username: `${authResponse.user.first_name} ${authResponse.user.last_name}`,
          });

          this.startUsageTracking();

          if (location.pathname.endsWith('/auth/login')) {
              return this.router.navigate(['/dashboard']);
          }
      })
      .catch(() => {
          this.router.navigate(['/auth/login']);
      })
      .finally(() => {
          this.isLoading = false
      })
  }

  // Usage stats (services/usage-tracker.service.ts), tagged with the release this tab loaded with
  private startUsageTracking() {
      this.backendApiService.get('/status').subscribe({
          next: (res: any) => this.usageTracker.start(res?.data?.version, res?.data?.usage_tracking),
          error: () => this.usageTracker.start(null),
      });
  }
}